require('./angulartics');
module.exports = 'angulartics';



//////////////////
// WEBPACK FOOTER
// ./~/angulartics/src/index.js
// module id = 904
// module chunks = 0